import app from 'flarum/forum/app';
import addPostTranslationIndicator from './extenders/addPostTranslationIndicator';
import addTranslationQuotaNotice from './extenders/addTranslationQuotaNotice';
export { default as extend } from './extend';
app.initializers.add('glowingblue-translate', () => {
  addPostTranslationIndicator();
  addTranslationQuotaNotice();
});